var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.isLoading)?_c('div',{staticClass:"isLoading"},[_c('span',{staticClass:"material-icons"},[_vm._v("search")])]):_c('div',{staticClass:"main"},[_c('Search'),_c('Info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }